<button (click)="open()">
    
        <div class="hero__image heroImg"></div><!-- /.hero__image -->

        <p class="hero__play js-play"  target="_blank">
            <img src="assets/img/svg/ico-play.svg" alt="Play button">
        </p>
   <!-- /.hero__media -->
</button>
